import { render, staticRenderFns } from "./yongjing.vue?vue&type=template&id=503754df&scoped=true&"
import script from "./yongjing.vue?vue&type=script&lang=js&"
export * from "./yongjing.vue?vue&type=script&lang=js&"
import style0 from "./yongjing.vue?vue&type=style&index=0&id=503754df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503754df",
  null
  
)

export default component.exports